import { FormattedMessage } from 'react-intl'
import { Image, TouchableOpacity, View } from 'react-native'
import styled from 'styled-components'
import { Icon } from '@flix/common/elements/images/Icon'
import { Backdrop, Background, CloseButton, Modal } from '@flix/common/elements/layout/Modal'
import { H3, Paragraph } from '@flix/common/elements/typography'
import messages from './messages'

const StyledModal = styled(Modal)`
  text-align: right;
  background: #000;
  width: 100%;
`

const WideBackground = styled(Background)`
  width: 80%;
`

const ScrollContainer = styled(View)`
  width: 100%;
  overflow-x: scroll;
`

const LifeCycleImage = styled(Image)`
  height: 440px;
  width: 2912px;
`

const Header = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: ${(props) => props.theme.colors.grayDarker};
  border-bottom-width: 1.5px;
  border-bottom-color: ${(props) => props.theme.colors.primary};
  padding: ${(props) => props.theme.spacing.md}px;
`

const Title = styled(H3)`
  margin-top: auto;
  margin-bottom: auto;
`

const ScrollRightMsg = styled(Paragraph)`
  margin-top: auto;
  margin-bottom: auto;
  padding: ${(props) => props.theme.spacing.sm}px;
  text-align: right;
  background: ${(props) => props.theme.colors.black};
`

const FilmPartnersPAModal = ({ imgSrc, imgSrcFullScreen, onRequestClose }) => (
  <StyledModal transparent onDismiss={onRequestClose}>
    <Backdrop dark onClick={onRequestClose}>
      <WideBackground onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>
            <FormattedMessage {...messages.lifecycle} />
          </Title>
          <CloseButton style={{ position: 'static' }} scale={0.75}>
            <TouchableOpacity onPress={onRequestClose}>
              <Icon name="close" scale={0.75} />
            </TouchableOpacity>
          </CloseButton>
        </Header>
        <ScrollRightMsg>
          <FormattedMessage {...messages.scrollRight} />{' '}
          <a
            href={imgSrcFullScreen}
            className="underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage {...messages.fullScreen} />
          </a>
        </ScrollRightMsg>
        <ScrollContainer>
          <LifeCycleImage source={imgSrc} />
        </ScrollContainer>
      </WideBackground>
    </Backdrop>
  </StyledModal>
)

export default FilmPartnersPAModal
